<template>
  <div class="">
    <div class="nav nav-tabs nav-fill">
      <a
        v-for="(tab, index) in tabs"
        :key="index"
        class="nav-item nav-link focusable"
        :ref="`refDefaultFocus${index}`"
        :id="`defaultFocusId${index}`"
        :class="[{active : tab.isActive, activeCustom: tab.isActiveCustom, defaultFocus: index===0 }, tab.classCustom]"
        data-toggle="tab"
        :href="`#${tab.href}`"
        :aria-controls="tab.href"
        :aria-selected="tab.isActive"
      >{{ tab.title }}</a>
    </div>
    <div class="tab-content">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab-pane fade"
        :class="[{show: tab.isActive}, {active: tab.isActive}]"
        :id="tab.href"
        aria-labelledby="nav-home-tab"
      >
        <component
            :is="tab.component"
            :data="tab.data"
            @quickPick="handleQuickPick"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(()=> {
        this.$refs.refDefaultFocus0[0].focus();
      },500)
    })
  },
  methods: {
    handleQuickPick(number) {
      this.$emit('quickPick', number)
    }
  }
}
</script>
<style scoped lang="scss" src="@/assets/scss/common/tab/tab-swift.scss"/>
